import React from 'react';

/**
 * Grille tableaux Mes Commandes — alignement partagé produits / RDV (présentation uniquement).
 * Colonnes communes (Total → Actions) : mêmes largeurs fixes sur les deux tableaux.
 * Colonne Produits ≈ Prestation + Durée pour aligner Total / Statut / Paiement / Date / Actions.
 */

/** Largeur min = somme des colonnes (rem) — colonnes communes alignées au pixel entre les 2 tableaux. */
export const MES_COMMANDES_MAQUETTE_TABLE_CLASS =
  'mes-commandes-maquette-table w-full min-w-[76rem] table-fixed border-collapse';

/** Vue plateforme Super Admin — colonne Commerçant supplémentaire. */
export const MES_COMMANDES_MAQUETTE_TABLE_PLATFORM_CLASS =
  'mes-commandes-maquette-table w-full min-w-[84rem] table-fixed border-collapse';

const TH =
  'py-3 text-left text-[11px] font-bold uppercase tracking-wider text-gray-500 whitespace-nowrap';
const TD = 'py-4 align-middle text-sm text-gray-900';

/** @param {number} index @param {number} total */
function headClass(index, total) {
  if (index === 0) return `${TH} pl-5 pr-3`;
  if (index === total - 1) return `${TH} pl-2 pr-6`;
  return `${TH} px-3`;
}

export function mesCmdHeadClass(index, total) {
  return headClass(index, total);
}

export function mesCmdTdRef() {
  return `${TD} pl-5 pr-3 align-top`;
}

export function mesCmdTdClient() {
  return `${TD} px-3 min-w-0 max-w-0`;
}

export function mesCmdTdCommercant() {
  return `${TD} px-3 min-w-0 max-w-0`;
}

export function mesCmdTdMain() {
  return `${TD} px-3`;
}

export function mesCmdTdDuree() {
  return `${TD} px-3 whitespace-nowrap`;
}

export function mesCmdTdTotal() {
  return `${TD} px-3 tabular-nums whitespace-nowrap`;
}

export function mesCmdTdStatut() {
  return `${TD} px-3 whitespace-nowrap`;
}

export function mesCmdTdPaiement() {
  return `${TD} px-3`;
}

export function mesCmdTdDate() {
  return `${TD} px-3 text-gray-600 whitespace-nowrap text-xs sm:text-sm`;
}

export function mesCmdTdActions() {
  return `${TD} pl-2 pr-6 whitespace-nowrap`;
}

/** @param {string[]} widths */
function ColGroup({ widths }) {
  return (
    <colgroup>
      {widths.map((width, index) => (
        <col key={index} style={{ width }} />
      ))}
    </colgroup>
  );
}

/** Colonnes communes (Total → Actions) — largeurs identiques sur le tableau RDV. */
const COL_REF = '6.5rem';
const COL_CLIENT = '7rem';
const COL_COMMERCANT = '8rem';
/** Produits (1 col) = Prestation + Durée (2 cols) */
const COL_PRODUITS = '20rem';
const COL_PRESTATION = '15.5rem';
const COL_DUREE = '4.5rem';
const COL_TOTAL = '5.75rem';
const COL_STATUT = '8.75rem';
const COL_PAIEMENT = '10rem';
const COL_DATE = '8.5rem';
const COL_ACTIONS = '9.25rem';

/**
 * Tableau commandes produits — micro-ajustement Commande/Client/Produits ;
 * Total → Actions identiques à la publication e66d207 (somme préfixe inchangée).
 */
const COL_REF_PRODUCT = '7.625rem';
const COL_CLIENT_PRODUCT = '7.375rem';
const COL_PRODUITS_PRODUCT = '18.75rem';
const PRODUCT_COL_WIDTHS = [
  COL_REF_PRODUCT,
  COL_CLIENT_PRODUCT,
  COL_PRODUITS_PRODUCT,
  '5.675rem',
  '8.675rem',
  '9.95rem',
  '8.45rem',
  COL_ACTIONS,
];

/** RDV | Client | Prestation | Durée | Total | Statut | Paiement | Date | Actions */
const RDV_COL_WIDTHS = [
  COL_REF,
  COL_CLIENT,
  COL_PRESTATION,
  COL_DUREE,
  COL_TOTAL,
  COL_STATUT,
  COL_PAIEMENT,
  COL_DATE,
  COL_ACTIONS,
];

export function MesCommandesProductColGroup() {
  return <ColGroup widths={PRODUCT_COL_WIDTHS} />;
}

export function MesCommandesRdvColGroup() {
  return <ColGroup widths={RDV_COL_WIDTHS} />;
}

const PLATFORM_PRODUCT_COL_WIDTHS = [
  COL_REF_PRODUCT,
  COL_CLIENT_PRODUCT,
  COL_COMMERCANT,
  COL_PRODUITS_PRODUCT,
  '5.675rem',
  '8.675rem',
  '9.95rem',
  '8.45rem',
  COL_ACTIONS,
];

const PLATFORM_RDV_COL_WIDTHS = [
  COL_REF,
  COL_CLIENT,
  COL_COMMERCANT,
  COL_PRESTATION,
  COL_DUREE,
  COL_TOTAL,
  COL_STATUT,
  COL_PAIEMENT,
  COL_DATE,
  COL_ACTIONS,
];

export function MesCommandesPlatformProductColGroup() {
  return <ColGroup widths={PLATFORM_PRODUCT_COL_WIDTHS} />;
}

export function MesCommandesPlatformRdvColGroup() {
  return <ColGroup widths={PLATFORM_RDV_COL_WIDTHS} />;
}

export const MES_CMD_ROW_ACTIONS_CLASS =
  'flex items-center justify-end gap-1 flex-nowrap w-full max-w-full';
